import { useEffect } from "react"
import { apiCaller } from "../../../services/apiCaller"
import { API } from "../../../services/services"
import {handleHasXTokenParamOrSendXToken, responseValidator} from "../../helpers"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { setUserSettings } from "../../../redux/slices/userSlice"
import { conditions } from "../../conditions/conditions"
import { ConditionName } from "../../../interfaces/enums"
import { shallowEqual } from 'react-redux'

const useUserSettings = () => {

    const disptach = useAppDispatch();
    const { isLogin } = useAppSelector(({ user: { isLogin } }) => ({ isLogin }), shallowEqual);
    const { isFetchDetails } = useAppSelector(({ videoData: { isFetchDetails } }) => ({ isFetchDetails }), shallowEqual);

    useEffect(() => {
        (async() => {
            if (conditions(ConditionName.getUserSetting)) {
                const { data, status } = await apiCaller({ url: API().user.settings, headers: handleHasXTokenParamOrSendXToken() });
                if (responseValidator(status)) disptach(setUserSettings({ ...data, quality: data.quality === null ? -1 : data.quality }));
            }
        })()
    }, [isLogin, isFetchDetails])
}

export default useUserSettings